import Navbar from "../../components/Navbar";
import FloatingActions from "../../components/FloatingActions";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Process from "./components/Process";
import Stats from "./components/Stats";
import Blog from "./components/Blog";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import { usePageMeta } from "../../hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "Hangar Muhendislik | Endustriyel Yapi Cozumleri",
    description:
      "Celik konstruksiyon, fabrika, depo ve hangar projelerinde anahtar teslim muhendislik cozumleri.",
  });

  return (
    <div className="font-body antialiased">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Services />
        <Projects />
        <Process />
        <Stats />
        <Blog />
        <CTA />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
